import React__default from 'react';
import styled, { css } from 'styled-components';
import { v as values } from '../../values-D-xU0n7p.js';
import { L as LabelContainer } from './LabelContainer-B-AAu4SJ.js';
import { V as VeryDissatisfied } from './Emoji/VeryDissatisfied-C-P0DUhe.js';
import { D as Dissatisfied } from './Emoji/Dissatisfied-nDd_Cz2z.js';
import { N as NeitherSatisfiedNorDissatisfied } from './Emoji/NeitherSatisfiedNorDissatisfied-BaUvU_JW.js';
import { S as Satisfied } from './Emoji/Satisfied-CP-kFmO2.js';
import { V as VerySatisfied } from './Emoji/VerySatisfied-CH_3swl5.js';

const valueEmojiMap = {
  [values[0]]: VeryDissatisfied,
  [values[1]]: Dissatisfied,
  [values[2]]: NeitherSatisfiedNorDissatisfied,
  [values[3]]: Satisfied,
  [values[4]]: VerySatisfied
};
const borderRadius = /*#__PURE__*/css(["border-radius:50%;"]);
const StyledLabelContainer = /*#__PURE__*/styled(LabelContainer).withConfig({
  componentId: "sc-storm-ui-30062554__sc-17s06f8-0"
})(["padding:0;", " border:none;"], borderRadius);
function EmojiLabel({
  checked,
  disabled,
  label,
  value
}) {
  const Emoji = valueEmojiMap[value];
  return /*#__PURE__*/React__default.createElement(StyledLabelContainer, {
    checked: checked,
    disabled: disabled,
    label: label
  }, /*#__PURE__*/React__default.createElement(Emoji, {
    checked: checked,
    disabled: disabled
  }));
}

export { EmojiLabel as E, borderRadius as b };
//# sourceMappingURL=EmojiLabel-FSCYBxuU.js.map
